import './form-util-transport-location.scss';

import { UtilTransportLocationFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";

type InputFormSchema = UtilTransportLocationFormSchema;
export function FormUtilTransportLocation() {
  const { control } = useFormContext<UtilTransportLocationFormSchema>();
  return (
    <div id="FormUtilTransportLocation" className="util-transport-location">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
    </div>
  );
}

export default FormUtilTransportLocation;